import { Filter, PaginatedResponse } from '@libs/models/common';
import { filterToQueryParams } from '../utils/filterToQueryParams';
import { QualificationFetchItem } from './types';
import { request } from '../request';
import { QualificationListItem } from '@libs/models/qualifications';

type fetchAgenciesListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Filter[];
};
export async function fetchQualificationsList(
  params?: fetchAgenciesListParams,
): Promise<PaginatedResponse<QualificationListItem[]>> {
  const filters = filterToQueryParams((params?.filters ?? []).map((fil) => ({ field: fil.key, value: fil.value })));

  const response = await request.get<QualificationFetchItem[]>('/qualifications', {
    // params: {
    //   pageNumber: params?.page || 1,
    //   pageSize: params?.size || 50,
    //   search: params?.search || undefined,
    //   ...filters,
    // },
  });

  return {
    hasNextPage: false,
    hasPreviousPage: false,
    items: response.data,
    pageNumber: 1,
    pageSize: response.data.length,
    totalCount: response.data.length,
  };
}
